import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, landingPath } from "@/context/AuthContext";
import { usePermissions } from "@/context/PermissionsContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const { loaded, isMenuAllowed } = usePermissions();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;

  if (!loaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!isMenuAllowed(user.role, location.pathname)) {
    return <Navigate to={landingPath(user.role)} replace />;
  }
  return children;
}
